module.exports = __webpack_public_path__ + "img/9.81e07ae2.svg";